import { useEffect, useState } from "react";
import { createDefaultUser, IPreference, IUser } from "interfaces";
import { useForm } from "hooks";
import { useApp, useData, useService } from "contexts";
import { MessageType } from "types";
import { Enums, Secrets } from "utils";
import { Validations } from "helpers";

export const useProfileForm = (initialUser: IUser, onSubmitCallback?: () => void) => {
  const { setUser } = useData();
  const { setFeedback, t } = useApp();
  const { userService } = useService();

  const [valid, setValid] = useState<boolean>(false);
  const [state, setState] = useState<IUser | null>(null);
  const [cuisines, setCuisines] = useState<string[]>([]);

  const updateCallback = (name: string, value: any) => {
    // TODO : to be improved
    if (name === "country") setState({ ...state, [name]: value, city: "" });
    else setState({ ...state, [name]: value });
  };

  const { onChange, onCustomChange } = useForm({}, undefined, undefined, updateCallback);

  useEffect(() => {
    const updatedState = {
      ...createDefaultUser(),
      ...initialUser,
      preferences: initialUser.preferences.map((item: IPreference) => item._id),
    };
    setState(updatedState as any);
    setCuisines(updatedState.cuisines);
  }, [initialUser]);

  const handleValidation = (valid: boolean) => setValid(valid);

  const handlePreferenceChange = (id: string, checked: boolean) => {
    if (!state) return;
    onCustomChange(
      "preferences",
      checked ? [...state.preferences, id] : state.preferences.filter((pref: any) => id !== pref)
    );
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!state) return;

    if (Validations.hasValue(state.password) && !valid) {
      setFeedback({ message: t.message.valiadtion.password_policy, severity: Enums.EnumFeedback.Error } as MessageType);
      return;
    } else if (Validations.hasValue(state.password)) {
      state.password = Secrets.hash(state.password);
    } else {
      delete state.password;
    }

    const response = await userService.update(state);
    if (response) {
      setUser(response);
      setFeedback({ message: t.message.feedback.request_update_success, severity: Enums.EnumFeedback.Success } as MessageType);
      onSubmitCallback?.();
    } else {
      setFeedback({ message: t.message.feedback.request_error, severity: Enums.EnumFeedback.Error } as MessageType);
    }
  };

  return {
    state,
    t,
    cuisines,
    onChange,
    onCustomChange,
    handleValidation,
    handlePreferenceChange,
    handleSubmit,
  };
};
